import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import { Upload, X } from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

export default function AddEmployee() {
  const breadcrumbItems = [
    { title: "Back To Employee List", link: "/employee" },
  ];
  return (
    <div className="">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Employee"
          title="Add Employee"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Card
        className=" p-4 shadow-sm border-0 w-100"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <Row className="mb-4">
          <Col
  lg={4}
  xs={12}
  className="d-flex justify-content-center align-items-center flex-column text-center mb-3 position-relative"
>
  {/* Image */}
  <img
    data-dz-thumbnail=""
    height="200"
    className="avatar-xxl rounded bg-light mb-2"
    src={"/avatar.jpg"}
    alt="User Avatar"
    style={{ cursor: "pointer" }}
    onClick={() => document.getElementById("avatarInput").click()}
  />

  {/* Hidden file input */}
  <input
    type="file"
    id="avatarInput"
    style={{ display: "none" }}
    accept="image/*"
    onChange={(e) => {
      if (e.target.files && e.target.files[0]) {
        const fileURL = URL.createObjectURL(e.target.files[0]);
        document.querySelector('img[data-dz-thumbnail]').src = fileURL;
      }
    }}
  />

  <small className="text-muted">Click image to change avatar</small>
</Col>

          <Col lg={1} className="d-none d-lg-block">
            <div
              className="vr"
              style={{ height: "100%", backgroundColor: "#ccc" }}
            />
          </Col>

          <Col lg={7} xs={12}>
            {/* <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
                     {userData?.username}
                   </h6> */}

            {/* <hr /> */}
            <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
              Add Employee
            </h6>

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-envelope me-2"></i>
              {/* Email: {userData?.email} */}

              <div>
                <label for="basiInput" class="form-label">
                  Full Name
                </label>
                <input type="text" class="form-control" id="basiInput" />
              </div>
            </h6>

            <div>
              <label for="basiInput" class="form-label">
                Email
              </label>
              <input type="email" class="form-control" id="basiInput" />
            </div>

            <div>
              <label for="basiInput" class="form-label">
                Contact Number
              </label>
              <input type="Number" class="form-control" id="basiInput" />
            </div>

            <div>
              <label for="basiInput" class="form-label">
                Designation
              </label>
              <input type="text" class="form-control" id="basiInput" />
            </div>

            <div>
              <label for="basiInput" class="form-label">
                Department
              </label>
              <input type="text" class="form-control" id="basiInput" />
            </div>

            <div>
              <label for="basiInput" class="form-label">
                Branch
              </label>
              <input type="text" class="form-control" id="basiInput" />
            </div>
          </Col>
        </Row>
      </Card>
      <Row>
        
      </Row>
    </div>
  );
}
